import React from 'react';
import { Redirect } from 'react-router-dom';

const RouteGuard = ({ children, allowedRoles }) => {
    const roles = JSON.parse(localStorage.getItem('roles') || '[]');

    const hasAccess = roles.some(role => allowedRoles.includes(role));

    if (!hasAccess) {
        return <Redirect to="/no-access" />;
    }

    return children;
};

export default RouteGuard;
